<template>
  <div class="row">
    <div class="col mb-2">
      <div class="flex justify-between items-center">
        <h4 class="font-weight-bold">Order Details</h4>
        <button v-if="confirmed" class="btn btn-success" type="button" @click="addPaymentDetails">
          <i class="icon icon-left mdi mdi-plus text-white"></i>
          Add Payment Details
        </button>

        <button v-if="draft || !disableEdit"
          class="bg-[#2463EB] p-[10px] rounded-[8px] text-white text-[14px leading-[20px] font-medium]" type="button"
          @click="addItem">
          <i class="mdi mdi-plus text-white"></i>
          Add Product
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table dataTable text-nowrap min-h-[150px]">
        <thead class="bg-white">
          <tr>
            <th scope="col">Item #</th>
            <th scope="col">Description</th>
            <th scope="col">Quantity</th>
            <th v-if="hasValidPrices" scope="col">Total</th>
            <th v-if="!disableEdit" scope="col"></th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-for="(item, index) in items" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.quantity }}</td>
            <td v-if="hasValidPrices">&#8358;{{ formatMoney(getItemTotal(item)) }}</td>
            <td v-if="!disableEdit">
              <span class="text-[14px] text-[#DC2828] leading-[20px] font-normal cursor-pointer"
                @click.prevent="removeItem(item.id)">
                Remove
              </span>
            </td>
          </tr>
          <tr v-if="items.length > 0 && hasValidPrices">
            <td></td>
            <td></td>
            <td>Total Payable</td>
            <td>&#8358; {{ formatMoney(totalAmount) }}</td>
            <td></td>
          </tr>
          <tr v-if="!items.length > 0">
            <td :colspan="hasValidPrices ? 6 : 5">
              <div class="text-center py-[100px]">
                <h4 class="text-[14px] text-[#353535] leading-[20px] font-normal">
                  No items in order
                </h4>
                <p class="text-[#96A0B5] text-[14px] leading-[20px] font-normal my-[8px]">
                  Click Add item button to add items to order
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { helper } from "@/helper";

export default {
  name: "ViewPurchaseOrderDetail",
  props: [
    "items",
    "disableEdit",
    "draft",
    "confirmed",
    "isBusyModal",
    "submit",
    "close",
    "onProceed",
    "isBusy",
    "deletePurchaseOrder",
  ],
  watch: {
    combinedItems: {
      handler(newVal, oldVal) {
        let user = newVal.first || null;
        if (user && user.id) {
          let items = newVal.second;
          if (items.length === 0) {
            return;
          }
          this.loader = true;
        } else {
          return;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data: () => ({
    loader: true,
    discounts: [],
    discount: 0,
  }),
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    combinedItems() {
      return { first: this.user, second: this.items };
    },
    hasValidPrices() {
      return this.items.length > 0 && this.items.every(item => item.price && item.price > 0);
    },
    subTotal() {
      return this.items.reduce(
        (sum, item) => sum + Math.round((item.quantity * item.price) * 100) / 100,
        0
      );
    },
    totalAmount() {
      return Math.round(this.subTotal * 100) / 100;
    },
  },

  methods: {
    getItemTotal(item) {
      return Math.round((item.price * item.quantity) * 100) / 100;
    },
    formatMoney(val) {
      const roundedVal = Math.round(val * 100) / 100;
      return helper.formatMoney(roundedVal);
    },
    addItem() {
      // eslint-disable-next-line no-undef
      $("#mod-item-add").modal("show");
    },

    addPaymentDetails() {
      // eslint-disable-next-line no-undef
      $("#mod-upload-details").modal("show");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    onEdit(item) {
      this.$emit("performEdit", { id: item.id, quantity: item.quantity });
    },

    removeItem(id) {
      this.$emit("onDeleteItem", id);
    },
    updateDiscountt() {
      this.$nextTick(() => {
        const discountToEmit = Number(this.totalDiscount) || 0;
        this.$emit("updateDiscountts", discountToEmit);
      });
    },
  },
};
</script>